import React from "react";
// ANT DESIGN COMPONENTS
import { Button, Spin } from "antd";
// UTILS
import floorButtonLabel from "../../../../utils/floorButtonLabel";
// INTERFACES
import { BankFloorInterface } from "../../../../interfaces/Bank.interface";

/**
 * One floor, as the circular button both floor surfaces draw.
 *
 * The shared thing between them is exactly this: the circle, and the rule for
 * what is written on it. Its GROUPING is not shared and deliberately is not
 * modelled here — `ActionFloorStrip` is a single-choice selector and wraps these
 * in a radiogroup, while `ActionFloorCard` offers a set of independent sends. A
 * `mode` prop covering both would have hidden a real semantic difference behind
 * a flag; leaving the container to each parent keeps each one's accessibility
 * honest.
 *
 * Whether this button participates in a selection is said by `selected`: a
 * boolean opts into the radio semantics, `undefined` means the button is a
 * plain action and gets none.
 */
export default function ActionFloorButton({
  floor,
  onClick,
  selected = undefined,
  loading = false,
  disabled = false,
}: {
  floor: BankFloorInterface;
  onClick: (floorIndex: number) => void;
  /** Boolean to join a single-choice group; undefined for a plain action. */
  selected?: boolean;
  loading?: boolean;
  disabled?: boolean;
}) {
  const inSelectionGroup = selected !== undefined;

  return (
    <Button
      className={`monitoring__modalSettings__button__1 actionCard__floorButton${
        selected ? " actionCard__floorButton--selected" : ""
      }`}
      shape="circle"
      role={inSelectionGroup ? "radio" : undefined}
      aria-checked={inSelectionGroup ? selected : undefined}
      disabled={disabled || loading}
      onClick={() => onClick(floor.floorIndex)}
    >
      {/* `floorButtonLabel` owns what is written here, shared with every other
          floor button in monitoring. This button contributes only the circle and
          its radio semantics. */}
      {loading ? <Spin spinning size="small" /> : <span>{floorButtonLabel(floor)}</span>}
    </Button>
  );
}
